module.exports = __webpack_public_path__ + "images/illustrations/illustration-storyline3@2x-767d7653630a753ca1e86d79563f9aa2.webp";